module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-bold-17642ebf.woff";